<template>
  <div>
    <h3>Attributes:</h3>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="value" label="参数" width="150"> </el-table-column>
      <el-table-column prop="describe" label="说明" width="150"> </el-table-column>
      <el-table-column prop="type" label="类型" width="200"> </el-table-column>
      <el-table-column prop="Option" label="可选值" width="150"> </el-table-column>
      <el-table-column prop="default" label="默认值" width="150"> </el-table-column>
      <el-table-column prop="required" label="必填" width="50"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        tableData: [
          {
            value: " gradient",
            describe: "线性渐变颜色",
            type: "Object",
            Option: "-",
            default: "{\n" +
              "        angle: 20,\n" +
              "        stops: [\n" +
              "          [\"#0359b5\", 0],\n" +
              "          [\"#0231b5\", 0.5],\n" +
              "          [\"#f6ce01\", 1],\n" +
              "        ]\n" +
              "      }",
            required: "true"
          }
        ]
      }
    }
  }
</script>

<style></style>
